/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import e from "prop-types";
import { validatePackage as p, IconWrap as l } from "@progress/kendo-react-common";
import { packageMetadata as m } from "./package-metadata.mjs";
import { xIcon as f, checkOutlineIcon as u, xOutlineIcon as y, infoCircleIcon as d, exclamationCircleIcon as k } from "@progress/kendo-svg-icons";
const h = "Close", b = {
  success: "check-outline",
  error: "x-outline",
  info: "info-circle",
  warning: "exclamation-circle"
}, g = {
  success: u,
  error: y,
  info: d,
  warning: k
}, o = class o extends t.Component {
  constructor(s) {
    super(s), p(m);
  }
  /**
   * @hidden
   */
  render() {
    const {
      onClose: s,
      className: i,
      closable: c = o.defaultProps.closable,
      type: n = o.defaultProps.type
    } = this.props;
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        dir: this.props.dir,
        className: "k-notification" + (i ? ` ${i}` : "") + (n.style === "none" ? "" : ` k-notification-${n.style}`) + (c ? " k-notification-closable" : ""),
        style: this.props.style
      },
      n.icon && /* @__PURE__ */ t.createElement(
        l,
        {
          className: "k-notification-status",
          name: b[n.style],
          icon: g[n.style]
        }
      ),
      /* @__PURE__ */ t.createElement("div", { className: "k-notification-content" }, this.props.children),
      c && /* @__PURE__ */ t.createElement("span", { className: "k-notification-actions" }, /* @__PURE__ */ t.createElement(
        "span",
        {
          className: "k-notification-action k-notification-close-action",
          title: h,
          onClick: (a) => {
            s && s.call(void 0, {
              target: this,
              syntheticEvent: a,
              nativeEvent: a.nativeEvent
            });
          },
          ...typeof c != "boolean" ? c : {}
        },
        /* @__PURE__ */ t.createElement(l, { name: "x", icon: f })
      ))
    );
  }
};
o.propTypes = {
  className: e.string,
  closable: e.oneOfType([e.bool, e.object]),
  dir: e.string,
  style: e.object,
  type: e.shape({
    style: e.oneOf(["none", "success", "error", "warning", "info"]),
    icon: e.bool
  }),
  onClose: e.func
}, o.defaultProps = {
  closable: !1,
  type: {
    style: "none",
    icon: !0
  }
};
let r = o;
export {
  r as Notification
};
